import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router';

import * as firebase from 'firebase/app';

@Injectable()
export class AuthService {

  private _user: firebase.User;

  constructor(
    public afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    private router: Router
  ) {
    afAuth.authState.subscribe(user => this.user = user);
  }

  get user(): firebase.User {
    return this._user;
  }

  set user(value: firebase.User) {
    this._user = value;
  }

  get authenticated(): boolean {
    return this._user !== null;
  }

  get id(): string {
    return this.authenticated ? this.user.uid : '';
  }

  // signInWithGoogle(): firebase.Promise<any> {
  //   return this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())
  //     .then(response => {
  //       this.db.object(`employees/${response.user.uid}`)
  //         .subscribe(user => {
  //           if (!user.$exists()) {
  //             let {displayName, email, emailVerified, photoURL, uid} = response.user;
  //             this.db.object(`employees/${response.user.uid}`).set({
  //               displayName,
  //               email,
  //               emailVerified,
  //               photoURL,
  //               uid
  //             })
  //           }
  //         });
  //     })
  //     .catch(err => console.log('ERRROR @ AuthService#signIn() :', err));
  // }

  signOut(): void {
    this.afAuth.auth.signOut().then(() => {
      this.router.navigateByUrl('/signin');
    });
  }

}



// WEBPACK FOOTER //
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/auth.service.ts